<template>
  <div
    class="fixed p-10 flex"
    style="
      left: 0;
      top: 0;
      height: 100vh;
      width: 100vw;
      z-index: 999999;
      backdrop-filter: blur(5px);
    "
    @click.self="closeModalView"
  >
    <div
      class="flex-1 bg-black rounded-lg flex shadow-md overflow-hidden relative"
    >
      <div class="h-full w-full flex flex-col bg-white">
        <div
          class="w-full bg-grey-light flex p-4 font-bold text-black"
          style="height: 45px"
          v-if="dataSource && dataSource.caption"
        >
          {{ dataSource.caption.text }}
        </div>
        <div class="flex-1 px-4 py-10">
          <fusioncharts
            v-if="chartLoaded"
            type="timeseries"
            width="100%"
            height="90%"
            dataFormat="json"
            :dataSource="dataSource"
          ></fusioncharts>
        </div>
      </div>

      <i
        @click="closeModalView"
        class="mr-4 mt-4 vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
        style="
          background: rgb(255, 255, 255);
          position: absolute;
          right: 0;
          top: 0;
        "
        >close</i
      >
    </div>
  </div>
</template>

<script>
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import TimeSeries from 'fusioncharts/fusioncharts.timeseries';
export default {
  props: { data: {} },
  components: {
    VueFusionCharts,
    FusionCharts,
    TimeSeries,
    // moment,
  },
  watch: {
    // data: {
    //   handler() {
    //     this.getChart();
    //   },
    // },
    // deep: true,
  },
  data() {
    return {
      dataSource: null,
      chartLoaded: false,
    };
  },
  methods: {
    closeModalView() {
      this.$emit('close-modal');
    },
    getChart() {
      const { data, dataSchema, dataSource } = this.data;
      this.dataSource = dataSource;
      const fusionTable = new FusionCharts.DataStore().createDataTable(
        data,
        dataSchema,
      );
      this.dataSource.data = fusionTable;
      this.chartLoaded = true;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.data) {
        this.getChart();
      }
    });
  },
};
</script>

<style scoped></style>
